export const sortBy = (type) => {
  return (a, b) => {
    if (a[type] < b[type]) { return -1; }
    if (a[type] > b[type]) { return 1; }
    return 0;
  };
};

export const uuidGenerator = (username) => {
  const requiredNameLen = 10;
  const nameLen = username.length;
  const requiredChars = '.xxxxxxxxx';
  let extraChars = '';
  if (nameLen < requiredNameLen) {
    const diff = requiredNameLen - nameLen;
    extraChars = 'x'.repeat(diff);
  }

  const totalChars = requiredChars + extraChars;

  return username.substring(0, requiredNameLen) + totalChars.replace(/[x]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const mapProperties = (a) => {
  const obj = {
    name: a.name,
    id: a.code
  };
  return obj;
};
